<template>
    <div class="area-wrapper">
      <iframe :src="this.detailVhall" :allowfullscreen="true" style="width:100%;height:100%;border:0;" ></iframe>
      <!-- <div class="prevBack" @click="prev">
        <img :src="require('../../assets/area/prevBack.png')" />
      </div> -->
      <ul class="leftList list">
        <li
          class="list-item"
          v-for="(item, index) in leftList"
          :key="index"
          @click="choose(item)"
          :class="{ active: item.chooseFlag == flagNum }"
        >
          {{ area.left[index] }}
          <img class="img-left" v-if="item.chooseFlag == flagNum" :src="item.icon2" alt=""/>
          <img class="img-left" v-else :src="item.icon1" alt=""/>
        </li>
      </ul>
      <ul class="rightList list">
        <li
          class="list-item"
          v-for="(item, index) in rightList"
          :key="index"
          @click="choose(item)"
          :class="{ active: item.chooseFlag == flagNum }"
        >
          <img class="img-right" v-if="item.chooseFlag == flagNum" :src="item.icon2" alt=""/>
          <img class="img-right" v-else :src="item.icon1" alt=""/>
          {{ area.right[index] }}
        </li>
      </ul>
      <!-- <div class="hotarea" @click="playVideo"></div>
      <div class="hotarea haibao" @click="show(8)"></div> -->
      <router-view></router-view>
      <About v-if="showFlag[1]" @cancel="cancel"/>
      <VideoList v-if="showFlag[2]" @cancel="cancel"/>
      <Product v-if="showFlag[3]" @cancel="cancel" @show="show"/>
      <Contact v-if="showFlag[4]" :exhibitionId="exhibitionId" @cancel="cancel"/>
      <AreaCard v-if="showFlag[5]" @cancel="cancel"/>
      <Chat v-if="showFlag[6]" @cancel="cancel"/>
      <ProductDetail
        :companyId="companyId"
        :exhibitionId="exhibitionId"
        v-if="showFlag[7]" @cancel="cancel" @show="show"
       />
      <Hb v-if="showFlag[8]" @cancel="cancel"/>
    </div>
</template>

<script>
import { mapState } from "vuex";
import api from "@/api";
// import { exhibition_id } from "@/utils/exhibitId";
import CommonVideo from "@/components/video";
import Lockr from "lockr";
import About from "@/views/about";
import VideoList from "@/views/videoList";
import Product from "@/views/product";
import Contact from "@/views/contact";
import AreaCard from "@/views/card";
import Chat from "@/views/chat";
import ProductDetail from "@/views/product/detail";
import Hb from "./components/hb";
import { DETAIL_PAGE_BUTTON } from '../../assets/common/data';
import { getUrlKey } from '../../utils/tools'
export default {
    components: {
        CommonVideo,
        About,
        VideoList,
        Product,
        Contact,
        AreaCard,
        Chat,
        ProductDetail,
        Hb
    },
    data() {
        return {
            companyId: '',
            exhibitionId: '',
            instanceId: '',
            leftList: [
                {
                    path: "/area/ztDetail/about",
                    chooseFlag: 1,
                    icon1: require("../../assets/area/11.png"),
                    icon2: require("../../assets/area/11.png")
                },
                {
                    path: "/area/ztDetail/videoList",
                    chooseFlag: 2,
                    icon1: require("../../assets/area/22.png"),
                    icon2: require("../../assets/area/22.png")
                },
                {
                    path: "/area/ztDetail/product",
                    chooseFlag: 3,
                    icon1: require("../../assets/area/33.png"),
                    icon2: require("../../assets/area/33.png")
                }
            ],
            rightList: [
                {
                    path: "/area/ztDetail/contact",
                    chooseFlag: 4,
                    icon1: require("../../assets/area/44.png"),
                    icon2: require("../../assets/area/44.png")
                },
                {
                    path: "/area/ztDetail/card",
                    chooseFlag: 5,
                    icon1: require("../../assets/area/55.png"), 
                    icon2: require("../../assets/area/55.png")
                },
                {
                    path: "/area/ztDetail/chat",
                    chooseFlag: 6,
                    icon1: require("../../assets/area/66.png"),
                    icon2: require("../../assets/area/66.png")
                }
            ],
            flagNum: 0,
            videoFlag: false,
            bc: "",
            aboutFlag: false,
            videoListFlag: false,
            showFlag: {
                1: false, //展台简介
                2: false, //视频列表
                3: false, //产品介绍
                4: false, //联系方式
                5: false, //名片交换
                6: false, //在线洽谈
                7: false, //产品介绍-详情
                8: false //海报
            },
            detailVhall: '',
            instance_id: '',
            exhibition_id: '',
            gues_id: ''
        };
    },
    mounted() {
      // this.instance_id = getUrlKey(instance_id)
      // console.log(this.instance_id)
      this.companyId = this.$route.query.company_id;
      this.exhibitionId = this.$route.query.exhibition_id;
      this.instanceId = this.$route.query.instance_id;
      this.gues_id = localStorage.getItem('GUEST_ID') || ''
      this.$root.$on("close", (idName, router) => {
          this.flagNum = 0;
      });
      this.bc = Lockr.get("bc");
      this.$store.dispatch("getUserInfo");
      this.getIntroData()
      this.sendVhallview()
    },
    methods: {
        sendVhallview(){
          this.$http({
            url: `https://gateway.cloudvhall.com:8443/log/api/v1/vhallview`,
            method: 'post',
            data: {
              exhibition_id: this.exhibitionId,
              vhall_id: this.instanceId,
              guest_id: this.gues_id
            }
          }).then(res => {
            if(res.res == 1){
              localStorage.setItem('GUEST_ID',res.guest_id)
            }
          }).catch((err) => {
            console.log(err)
          })
          // api.sendVhallview({
            
          //     exhibition_id: this.exhibitionId,
          //     vhall_id: this.instanceId,
          //     guest_id: this.Token
            
          // }).then((res) =>{
          //   console.log(res)
          // })
        },
        prev() {
          this.$router.go(-1);
        },
        playVideo() {
            this.showFlag[2] = true;
        },
        getIntroData() {
          api.getExhibitionDetali({
            id: this.companyId,
            params: {
              exhibition_id: this.exhibitionId
            }
          }).then((res) => {
              if(res.res == 1){
                  this.detailVhall = res.info.vhall.url
                  console.log(this.detailVhall)
              }
          });
          // return new Promise((resolve, reject) => {
            
          // })
        },
        getVideoData() {
          return new Promise((resolve, reject) => {
            api.getExhibitionVideo({
              exhibition_id: this.exhibitionId,
              hall_id: this.instanceId,
              type: "video"
            }).then((res) => {
              resolve(res)
            });
          })
        },
        getProductData() {
          return new Promise((resolve, reject) => {
            api.getExhibitionProduct({
              exhibition_id: this.exhibitionId,
              company_id: this.companyId
            }).then((res) => {
              resolve(res)
            });
          })
        },
        getContactData() {

        },
        getCardData() {

        },
        getChatData() {

        },
        getProductDetailData() {

        },
        getPosterData() {

        }, 
        async choose(item) {
            const { chooseFlag } = item;
            let data;
            let isData = false;
            switch (chooseFlag) {
              case DETAIL_PAGE_BUTTON.INTRO:
                // data = await this.getIntroData();
                isData = true;
                break;
              case DETAIL_PAGE_BUTTON.VIDEO:
                data = await this.getVideoData();
                if (data.data.length !== 0) isData = true;
                break;
              case DETAIL_PAGE_BUTTON.PRODUCT:
                data = await this.getProductData();
                if (data.list.length !== 0) isData = true;
                break;
              case DETAIL_PAGE_BUTTON.CONTACT:
                data = await this.getContactData;
                isData = true;
                break;
              case DETAIL_PAGE_BUTTON.CARD:
                data = await this.getCardData;
                isData = true;
                break;
              case DETAIL_PAGE_BUTTON.CHAT:
                data = await this.getChatData;
                isData = true;
                break;
              case DETAIL_PAGE_BUTTON.PRODUCT_DETAIL:
                // data = await this.getProductDetailData;
                // TODO
                isData = true;
                break;
              case DETAIL_PAGE_BUTTON.POSTER:
                // data = await this.getPosterData;
                // TODO
                isData = true;
                break;
              default:
                break;
            }
            if (!isData) {
              this.$message.info(this.$t("area").noData)
              return
            }
            if (this.showUserModal) {
                this.$store.commit("setState", {
                    showUserModal: false
                });
            }
            if (chooseFlag === 6 && !this.userInfo.id) {
                this.$message.error(this.$t("area").loginTip);
                return;
            }
            for (item in this.showFlag) {
                this.showFlag[item] = false;
            }
            this.flagNum = chooseFlag;
            this.showFlag[chooseFlag] = true;
        },
        cancel(cancelFlag) {
            this.showFlag[cancelFlag] = false;
        },
        show(cancelFlag) {
            this.showFlag[cancelFlag] = true;
        }
    },
    computed: {
        ...mapState(["userInfo", "showUserModal"]),
        area() {
            return this.$t("area");
        }
    },
    watch: {
      '$route'() {
          this.companyId = this.$route.query.company_id;
          this.exhibitionId = this.$route.query.exhibition_id;
          this.instanceId = this.$route.query.instance_id;
          this.getIntroData()
          this.sendVhallview()
      }
    }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/var.scss";

.area-wrapper {
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    background-color: #ffffff;
    background-size: 100% 100%;
    height: 100vh;
    .prevBack {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 37px;
      top: 145px;
      z-index: 100;
      width: 58px;
      height: 58px;
      background: #ffffff;
      border-radius: 50%;
    }
    .hotarea {
        width: 80px;
        height: 80px;
        position: absolute;
        top: 55%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: url("~@/assets/hot.gif") no-repeat center;
        background-size: 100% 100%;
        cursor: pointer;
    }
    .haibao {
        left: 65%;
    }
    .list {
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        width: 220px;
        &-item {
            position: relative;
            width: 220px;
            height: 50px;
            background: #ffffff;
            box-shadow: 0 0 4px 3px rgba(255,255,255,0.1);
            margin-bottom: 54px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 600;
            color: rgba(9, 70, 140, 1);
            cursor: pointer;
            &.active {
                color: rgba(9, 70, 140, 0.45);
                img {
                    opacity: 0.45;
                }
            }
            .img-left {
                position: absolute;
                right: 0;
                width: 18px;
                // height: 16px;
                margin-left: 7px;
                margin-right: 7px;
                opacity: 1;
            }
            .img-right {
              position: absolute;
              left: 0;
              width: 18px;
              // height: 16px;
              margin-left: 7px;
              margin-right: 7px;
              opacity: 1;
            }
        }
    }
    .rightList {
        right: 0;
        > li {
            border-radius: 12px 0 0 12px;
        }
    }
    .leftList {
        left: 0;
        > li {
            border-radius: 0 12px 12px 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/area/zhantaiDetail.vue